export var getEmojiImageUrl = function (id) {
    return "/blockly/media/dance/ai/emoji/".concat(id, ".svg");
};
